import React from 'react';
import { generateContract } from '../utils/contractGenerator';
import '../utils/contractStyles.css';

const ContractPreview = ({ projectType, companyName, customerName }) => {
  const contract = generateContract(projectType || 'technical');
  
  return (
    <div className="contract-document">
      <h1 className="contract-title">{contract.title}</h1>
      <p className="contract-date">Effective Date: {new Date().toLocaleDateString()}</p>
      <p className="contract-parties">
        <strong>Between:</strong> {companyName || 'The Service Provider'} and {customerName || 'The Client'}
      </p>
      
      {Object.entries(contract.sections).map(([key, section]) => (
        <section key={key} className="contract-section">
          <h2 className="section-title">{section.title}</h2>
          <p className="section-content">{section.content}</p>
        </section>
      ))}
      
      <div className="contract-signature">
        <p>By executing this agreement, both parties acknowledge their understanding and acceptance of these terms.</p>
        <div className="signature-block">
          <p>_______________________________</p>
          <p>Service Provider Signature</p>
        </div>
        <div className="signature-block">
          <p>_______________________________</p>
          <p>Client Signature</p>
        </div>
      </div>
    </div>
  );
};

export default ContractPreview;
